import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { DataGrid } from '@material-ui/data-grid';
import { Button, Modal, Form, Row, Col, InputGroup } from "react-bootstrap";
import SearchIcon from '@material-ui/icons/Search';
import * as Admin from "../../../store/ducks/admin.duck";
import * as Forms from "../../../store/ducks/forms.duck";
import { Grid, Paper } from '@material-ui/core';
import { ToastContainer, Flip } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import 'bootstrap/dist/css/bootstrap.min.css'
import '../../../../_metronic/_assets/css/app.css';
import '../../../../_metronic/_assets/css/app2.css';

export default function Surveys() {

  const [searchTerm, setSearchTerm] = useState('')
  const forms = useSelector(state => state.forms.Forms);
  const surveys = useSelector(state => state.admin.Surveys)
  const filteredSurveys = surveys.filter(surveys => surveys.name.toLowerCase().search(searchTerm.toLowerCase()) > -1 || searchTerm.length === 0 )
  const dispatch = useDispatch()
  useEffect( () => { dispatch(Admin.actions.fetchSurveys()) }, [dispatch] )
  useEffect( () => { dispatch(Forms.actions.fetchForms()) }, [dispatch] )

  var [show, setShow] = useState(false);
  var [currentSurveyID,setCurrentSurveyID] = useState();
  var [currentName,setCurrentName] = useState();
  var [currentSurveyType,setCurrentSurveyType] = useState();
  var [currentSurveyTypeSetting1,setCurrentSurveyTypeSetting1] = useState();
  var [currentSurveyCondition1,setCurrentSurveyCondition1] = useState();
  var [currentSurveyCondition2,setCurrentSurveyCondition2] = useState();
  var [currentSurveyMonths,setCurrentSurveyMonths] = useState();
  var [currentStatus,setCurrentStatus] = useState();
  
  const loadSurveyDetail = (thisSurvey) => {
    setCurrentSurveyID(thisSurvey.id)
    setCurrentName(thisSurvey.name)
    setCurrentSurveyType(thisSurvey.surveytype)
    setCurrentSurveyTypeSetting1(thisSurvey.surveytypesetting1)
    setCurrentSurveyCondition1(thisSurvey.surveycondition1)
    setCurrentSurveyCondition2(thisSurvey.surveycondition2)
    setCurrentSurveyMonths(thisSurvey.surveymonths)
    setCurrentStatus(thisSurvey.status)
    setShow(true)
  }

  const createNewSurvey = (thisSurvey) => {
    setCurrentSurveyID(0)
    setCurrentName()
    setCurrentName()
    setCurrentSurveyType()
    setCurrentSurveyTypeSetting1()
    setCurrentSurveyCondition1()
    setCurrentSurveyCondition2()
    setCurrentSurveyMonths()
    setCurrentStatus('Active')
    setShow(true)
  }

  function putSurvey() {
    // Create payload to send to API 
    var payload = {
        id : currentSurveyID,
        name : currentName,
        surveytype : currentSurveyType,
        surveytypesetting1 : currentSurveyTypeSetting1,
        surveycondition1 : currentSurveyCondition1,
        surveycondition2 : currentSurveyCondition2,
        surveymonths : currentSurveyMonths,
        status : currentStatus
    }
    //
    process.env.REACT_APP_DEBUG && console.log(payload);
    process.env.REACT_APP_DEBUG && console.log ('Saving data');
    // Save update 
    dispatch(Admin.actions.putSurvey(payload));
    setShow(false);
  }


  const columns = [
    { field: 'id', headerName: 'ID', width: 100,  hide: true },
    { field: 'name', headerName: 'Name', width: 300,  
      renderCell: (params) => (
        <strong>
            <div onClick={() => loadSurveyDetail(surveys.find(survey => survey.id === params.row.id))} className="cell-Link" >
              {params.value}
            </div>
        </strong>
      ),  
    },



    { field: 'status', headerName: 'Status', width: 120 },
  ];

  
  function handleClose() {
    setShow(false);
  }  

  const handleSearch = (event) => {
    const searchTerm = event.target.value    
    setSearchTerm(searchTerm)
  }


  return (
    <>
      <Grid container direction="row" justifyContent="space-between">
        <Grid item><h4 style={{ marginBottom: 12 }}>Survey Maintenance</h4></Grid>
      </Grid>

      <Paper> 
        <Grid container justifyContent="space-between" style={{ padding: 10 }}>
          <Grid item style={{ marginTop: 2, marginLeft: 10 }}>
            <InputGroup size="sm" >
              <InputGroup.Prepend>
                <InputGroup.Text>
                  <SearchIcon fontSize="small" style={{ marginLeft: -4 }} />
                </InputGroup.Text>
              </InputGroup.Prepend>
              <Form.Control                  
                  type="text"
                  value={searchTerm}
                  onChange={(event) => handleSearch(event)}
                  autoComplete='OFF'
                />
              </InputGroup>
          </Grid>
          <Grid item style={{ marginLeft: 20, marginRight: 10 }}>
            <Button variant="primary" size="sm" onClick={() => createNewSurvey()}>
              Create Survey
            </Button>
          </Grid>
        </Grid>
      </Paper>


      { surveys ? 
        <Paper style={{ height: 700 }}>
          <DataGrid rows={filteredSurveys} columns={columns} pageSize={10} checkboxSelection={false} rowHeight={40} />
        </Paper>
      : ('None')
      }

      <Modal show={show} onHide={handleClose} dialogClassName="contracts-modal" >
        <Modal.Header closeButton className="contracts-modal">
          <Modal.Title>Survey Maintenance </Modal.Title>
        </Modal.Header>
        <Modal.Body className="contracts-modal">
          <Row>
            <Col md="12">
              <Form.Group >
                <Form.Label>Name</Form.Label>
                <Form.Control type="text" name="name" defaultValue={currentName} onBlur={(event) => setCurrentName(event.target.value)} autoComplete='new-password' />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md="3">
              <Form.Group >
                <Form.Label>Survey Type</Form.Label>
                <Form.Control as="select" defaultValue={currentSurveyType} onBlur={(event) => setCurrentSurveyType(event.target.value)}>
                    <option value="Booking">Booking</option>
                    <option value="Client">Client</option>
                </Form.Control>
              </Form.Group>
            </Col>     
            <Col md="3">
              <Form.Group >
                <Form.Label>Send Form After</Form.Label>
                <Form.Control type="text" name="surveycondition1" defaultValue={currentSurveyCondition1} onBlur={(event) => setCurrentSurveyCondition1(event.target.value)} autoComplete='new-password' />
              </Form.Group>
            </Col>
            {/* <Row>
              <Col md="3">
                <Form.Group >
                  <Form.Label>Send Form After</Form.Label>
                  <Form.Control type="text" name="surveycondition1" defaultValue={currentSurveyCondition1} onBlur={(event) => setCurrentSurveyCondition1(event.target.value)} autoComplete='new-password' />
                </Form.Group>
              </Col>
            </Row> */}
            <Col md="6">
              <Form.Group >
                <Form.Label>Number of Months (in the past to review) (i.e. 4)</Form.Label>
                <Form.Control type="text" name="surveymonths" defaultValue={currentSurveyMonths} onBlur={(event) => setCurrentSurveyMonths(event.target.value)} autoComplete='new-password' />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md="8">
              <Form.Group >
                <Form.Label>Form Selection</Form.Label>
                <Form.Control as="select" defaultValue={currentSurveyTypeSetting1} onBlur={(event) => setCurrentSurveyTypeSetting1(event.target.value)}>
                  {forms && forms.map((form) => (  
                    <option value={form.formID}>{form.formName}</option>
                  ))}
                </Form.Control>
                </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <Form.Label style={{fontWeight: 600}}>Changing Form may retrigger forms being sent to clients from the past</Form.Label>
            </Col>
          </Row>
          <Row style={{marginTop: 10}}>
            <Col md="3">
              <Form.Group >
                <Form.Label>Status</Form.Label>
                <Form.Control as="select" defaultValue={currentStatus} onBlur={(event) => setCurrentStatus(event.target.value)}>
                    <option value="Active">Active</option>
                    <option value="InActive">InActive</option>
                </Form.Control>
              </Form.Group>
            </Col>     
          </Row>
        </Modal.Body>
        <Modal.Footer className="contracts-modal">
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={putSurvey}>
            Save
          </Button>
        </Modal.Footer>

      </Modal>


      <ToastContainer
        position="bottom-right"
        transition={Flip}
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />     
    </>
  )
}
